import React from "react";
import { SERVICE_STATUS_CONFIG } from "../../utils/constants";
import "./ServiceStatusBadge.css";

/**
 * Badge de status de atendimento
 */
const ServiceStatusBadge = ({ status, size = "normal", showIcon = true, className = "" }) => {
  const config = SERVICE_STATUS_CONFIG[status] || SERVICE_STATUS_CONFIG.new;

  return (
    <span
      className={`sc-status-badge sc-status-badge--${size} ${className}`}
      style={{
        backgroundColor: config.bgColor,
        color: config.color,
      }}
    >
      {showIcon && <span className="sc-status-badge__icon">{config.icon}</span>}
      <span className="sc-status-badge__label">{config.label}</span>
    </span>
  );
};

export default ServiceStatusBadge;
